import { render, staticRenderFns } from "./PartiallyAcceptedAlert.vue?vue&type=template&id=ab2896e2"
import script from "./PartiallyAcceptedAlert.vue?vue&type=script&lang=js"
export * from "./PartiallyAcceptedAlert.vue?vue&type=script&lang=js"
import style0 from "./PartiallyAcceptedAlert.vue?vue&type=style&index=0&id=ab2896e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports